import { initializeApp, getApps, getApp, FirebaseApp } from "@firebase/app";
import { Firestore, initializeFirestore, connectFirestoreEmulator } from "@firebase/firestore";
import { Auth, getAuth } from "@firebase/auth/cordova";
import { FirebaseStorage, getStorage } from "firebase/storage";
import { environment } from "src/environments/environment";

export const firebaseApp: FirebaseApp = getApps().length === 0 ? initializeApp(environment.firebase) : getApp();
// Force HTTP long polling: the default WebChannel transport intermittently
// stalls for exactly 30s on iOS WKWebView (B2C-656).
export const fireDb: Firestore = initializeFirestore(firebaseApp, {
  experimentalForceLongPolling: true,
});
export const fireAuth: Auth = getAuth(firebaseApp);
export const fireStorage: FirebaseStorage = getStorage(firebaseApp);

//connectFirestoreEmulator(fireDb, '127.0.0.1', 8080);